// app.scrollToTop.run.js

"use strict";


scroll.$inject = ["$window", "$transitions", "$timeout"];
function scroll($window, $transitions, $timeout) {
    // Evita que el navegador restaure una posición de scroll antigua al
    // recargar o volver atrás; en una SPA el scroll lo controla la aplicación.
    if ("scrollRestoration" in $window.history) {
        $window.history.scrollRestoration = "manual";
    }

    $transitions.onSuccess({},function() {
        $window.scrollTo(0,0);

        // Criterio 2.4.3 (Orden del foco): en una SPA el cambio de ruta no
        // mueve el foco. Se lleva al contenido principal para que teclado y
        // lectores de pantalla empiecen a leer la nueva vista.
        $timeout(() => {
            const main = $window.document.getElementById('main-content');
            if (main && typeof main.focus === 'function') {
                // preventScroll evita que el foco desplace la página: el margen
                // superior de la vista colapsa con <main> y el navegador lo
                // alineaba en el borde superior, ocultando el h1 bajo la
                // cabecera fija.
                try {
                    main.focus({ preventScroll: true });
                } catch (error) {
                    main.focus();
                }
                $window.scrollTo(0,0);
            }
        }, 0);
    });
}

export { scroll };
